import moment from "moment";

export const formatDate = (date) => {
  return moment(date).format("MM-DD-YYYY");
};

export const formatMonth = (month) => {
  return moment(new Date(month)).format("MM");
};

export const formatFullMonthName = (month) => {
  return moment(new Date(month)).format("MMMM");
};

export const formatYear = (year) => {
  return moment(new Date(year)).format("YYYY");
};
export const formatMonthYearDefault = (date) => {
  return moment(new Date(date)).format("YYYY-MM");
};
export const formatMonthYear = (month, year) => {
  month = formatMonth(month);
  year = formatYear(year);
  return moment(new Date(`${year}-${month}`)).format("YYYY-MM");
};
